/**
 * This class initiates various logic for our site header
 * 
 * @export
 * @class SiteHeader
 */
import { BaseModule } from '../../helpers/base_module';

export class SiteHeader extends BaseModule {
    public triggerDisabled = false;
    private backgroundTriggerPoint = 100;
    private container = <Element>document.getElementById('js-site-header');


    /**
     * Initiate our class
     * 
     * @class SiteHeader
     */
    constructor() {
        super();
        if(!this.container) return;
        this.makePublic('siteHeader');

        this.toggleBackgroundOnScroll();
    }


    /**
     * Add's a background to the header if the current vertical scroll position is greater than backgroundTriggerPoint
     * 
     * @private
     * @memberof SiteHeader;
     */
    private toggleBackgroundOnScroll(): void {
        window.addEventListener('scroll', () => {
            this.toggleBackground();
        });
    }


    /**
     * Toggle the background based on the current scroll position
     * 
     * @public
     * @memberof SiteHeader
     */
    public toggleBackground(): void {
        if(!this.triggerDisabled) {
            if(window.pageYOffset >= this.backgroundTriggerPoint) {
                this.addBackgroundClass();
            } else {
                this.removeBackgroundClass();
            }
        }
    }


    /**
     * Add's the background class to the header
     * 
     * @public
     * @memberof SiteHeader
     */
    public addBackgroundClass(): void {
        this.container.classList.add('c-site-header--is-fixed');
    }


    /**
     * Add's the background class to the header
     * 
     * @public
     * @memberof SiteHeader
     */
    public removeBackgroundClass(): void {
        this.container.classList.remove('c-site-header--is-fixed');
    }
}
